<template>
  <div class="mit-admin-page mit-page">

    <v-container fluid>
        <v-row>
          <v-col cols="12" class="d-flex">
            <v-card class="mit-info-card" style="width:100%">
                <v-card-title>Admin - Space Management</v-card-title>
                <v-card-subtitle class="caption">CSAIL Space Management area for admins</v-card-subtitle>
                <v-divider></v-divider>

                <v-card-text>
                    <div>
                        <a href="/admin/settings/buildings" style="text-decoration:none">
                          <h3 class="pt-5" to="/admin/settings/buildings">
                            <v-icon color="primary darken-1" class="pr-3">mdi-office-building-cog</v-icon>Building Settings
                          </h3>
                        </a>
                        <p>Set the active building version and other default settings. </p>
                        <!-- <v-btn color="primary" to="/admin/settings">Settings</v-btn> -->
                    </div>
                    <div>
                        <a href="/admin/spaces/upload" style="text-decoration:none">
                          <h3 class="pt-5">
                            <v-icon color="primary darken-1" class="pr-3">mdi-map-plus</v-icon>Upload Facility Spaces
                          </h3>
                        </a>
                        <p>Upload a new space version to the application from a MIT facility json export. </p>
                        <!-- <v-btn color="primary" to="/admin/spaces/upload">Upload</v-btn> -->
                    </div>
                    <div>
                        <a href="/admin/settings" style="text-decoration:none">
                          <h3 class="pt-5" to="/admin/settings">
                            <v-icon color="primary darken-1" class="pr-3">mdi-cog</v-icon>Settings
                          </h3>
                        </a>
                        <p>Settings for the application and configuration that applies to all buildings.</p>
                        <!-- <v-btn color="primary" to="/admin/settings">Settings</v-btn> -->
                    </div>
                    <!-- <div>
                        <a href="/admin/spaces/edit" style="text-decoration:none">
                          <h3 class="pt-5">
                            <v-icon color="primary darken-1" class="pr-3">mdi-pencil-outline</v-icon>Edit Facility Spaces
                          </h3>
                        </a>
                        <p>Change or delete facility spaces. </p>
                    </div>
                    <div>
                        <a href="/admin/spaces/edit" style="text-decoration:none">
                          <h3 class="pt-5">
                            <v-icon color="primary darken-1" class="pr-3">mdi-map-marker-plus-outline</v-icon>Create Objects
                          </h3>
                        </a>
                        <p>Create objects to that can be drawn on the map. This is a list of objects that can be added by map managers.</p>
                    </div> -->

                </v-card-text>

            </v-card>
          </v-col>
        </v-row>
    </v-container>
  </div>
</template>

<script>
  import BaseMitConfigService from '../../../base/services/BaseMitConfigService.js';
  import MitFeaturesService from '../../services/MitFeaturesService.js';

  export default {
    name: 'MitAdminPage',
    components: {
    },
    data: function() {
      return {
        showResetFeature:false,
        resetByEmail:false
      }
    },
    created() {
      this.showResetFeature = BaseMitConfigService.getFeatureEnabled(MitFeaturesService.names.ADMIN_RESET_PASSWORD);
      this.resetByEmail = BaseMitConfigService.getFeatureEnabled('email-reset');
    },
    props: {
      userModel: Object, //comes from route
      userRoles: Object //comes from route
    },
    methods: {
    }
  }
</script>

<style lang="scss" scoped>
  .mit-app-loading-center {
    display: flex;
    align-items: center;
    justify-content: center;
    height:100vh;
  }
</style>
